import { render, staticRenderFns } from "./userProfilCompagnieTransport.vue?vue&type=template&id=167be8ec&scoped=true"
import script from "./userProfilCompagnieTransport.vue?vue&type=script&lang=js"
export * from "./userProfilCompagnieTransport.vue?vue&type=script&lang=js"
import style0 from "./userProfilCompagnieTransport.vue?vue&type=style&index=0&id=167be8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167be8ec",
  null
  
)

export default component.exports